import { createContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { SimpleDataCacheService } from '@/lib/utils/simple-data-cache-service';
import { sortCultureByBook } from './culture-by-book-data-service';

interface CultureByBookDataContextType {
  cultureByBook: CultureByBook[];
  getCultureByBookByBook: (book: string) => CultureByBook | undefined;
}

export const CultureByBookDataContext = createContext<CultureByBookDataContextType | undefined>(undefined);

interface CultureByBookDataProviderProps {
  children: ReactNode;
  cultureByBook: CultureByBook[];
}

export function CultureByBookDataProvider({ children, cultureByBook: initialData }: CultureByBookDataProviderProps) {
  const [cacheService] = useState(() =>
    new SimpleDataCacheService<CultureByBook>(
      initialData,
      sortCultureByBook
    )
  );

  // Track the current items in state so the component re-renders when data changes
  const [cultureByBook, setCultureByBook] = useState<CultureByBook[]>(initialData);

  useEffect(() => {
    cacheService.setNewItems(initialData);
    setCultureByBook(cacheService.getItems());
  }, [initialData, cacheService]);

  const getCultureByBookByBook = (book: string): CultureByBook | undefined => {
    return cultureByBook.find(item => item.book === book);
  };

  return (
    <CultureByBookDataContext.Provider
      value={{
        cultureByBook,
        getCultureByBookByBook
      }}
    >
      {children}
    </CultureByBookDataContext.Provider>
  );
}

